/**
 * Kadmin Light Theme
 */
import { createTheme } from "@mui/material/styles";

import colors from "assets/theme/base/colors";
import breakpoints from "assets/theme/base/breakpoints";
import typography from "assets/theme/base/typography";
import boxShadows from "assets/theme/base/boxShadows";
import borders from "assets/theme/base/borders";
import globals from "assets/theme/base/globals";

import boxShadow from "assets/theme/functions/boxShadow";
import hexToRgb from "assets/theme/functions/hexToRgb";
import linearGradient from "assets/theme/functions/linearGradient";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

import {
  sidenav, list, listItem, listItemText, card,
  button, iconButton, buttonBase,
  menu, menuItem, divider, popover,
  tableContainer, tableHead, tableCell,
  tabs, tab, linearProgress, breadcrumbs, slider,
  avatar, tooltip, icon, svgIcon, link,
  appBar, dialog, dialogTitle, dialogContent, dialogActions,
  stepper, step, stepConnector, stepLabel, stepIcon,
  container,
} from "assets/theme/components";

import {
  input, inputOutlined, inputLabel, textField, select,
  autocomplete, checkbox, radio, switchButton, formControlLabel, formLabel,
} from "assets/theme/components/form";

export default createTheme({
  breakpoints: { ...breakpoints },
  palette: { ...colors },
  typography: { ...typography },
  boxShadows: { ...boxShadows },
  borders: { ...borders },
  functions: { boxShadow, hexToRgb, linearGradient, pxToRem, rgba },

  components: {
    MuiCssBaseline: { styleOverrides: { ...globals, ...container } },
    MuiDrawer: { ...sidenav },
    MuiList: { ...list },
    MuiListItem: { ...listItem },
    MuiListItemText: { ...listItemText },
    MuiCard: { ...card },
    MuiButton: { ...button },
    MuiIconButton: { ...iconButton },
    MuiButtonBase: { ...buttonBase },
    MuiInput: { ...input },
    MuiInputLabel: { ...inputLabel },
    MuiOutlinedInput: { ...inputOutlined },
    MuiTextField: { ...textField },
    MuiSelect: { ...select },
    MuiAutocomplete: { ...autocomplete },
    MuiCheckbox: { ...checkbox },
    MuiRadio: { ...radio },
    MuiSwitch: { ...switchButton },
    MuiFormControlLabel: { ...formControlLabel },
    MuiFormLabel: { ...formLabel },
    MuiMenu: { ...menu },
    MuiMenuItem: { ...menuItem },
    MuiDivider: { ...divider },
    MuiPopover: { ...popover },
    MuiTableContainer: { ...tableContainer },
    MuiTableHead: { ...tableHead },
    MuiTableCell: { ...tableCell },
    MuiTabs: { ...tabs },
    MuiTab: { ...tab },
    MuiLinearProgress: { ...linearProgress },
    MuiBreadcrumbs: { ...breadcrumbs },
    MuiSlider: { ...slider },
    MuiAvatar: { ...avatar },
    MuiTooltip: { ...tooltip },
    MuiIcon: { ...icon },
    MuiSvgIcon: { ...svgIcon },
    MuiLink: { ...link },
    MuiAppBar: { ...appBar },
    MuiDialog: { ...dialog },
    MuiDialogTitle: { ...dialogTitle },
    MuiDialogContent: { ...dialogContent },
    MuiDialogActions: { ...dialogActions },
    MuiStepper: { ...stepper },
    MuiStep: { ...step },
    MuiStepConnector: { ...stepConnector },
    MuiStepLabel: { ...stepLabel },
    MuiStepIcon: { ...stepIcon },
  },
});
